export default {
    name: 'OnboardingIndex'
}